<template>
  <div class="section-panel text-center">
    <div class="container-fluid">
      <div class="title">
        <h3>{{$t(`helpcenter.title`)}}</h3>
      </div>
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12">
            <div class="card plain">
              <div class="card-header p-4">
                 <el-input
                  placeholder="Buscar"
                  v-model="filter"
                  prefix-icon="el-icon-search"
                  >
                </el-input>
              </div>
              <div class="card-body p-4">
                <el-collapse accordion>
                  <el-collapse-item v-for="(h, i) in items" :key="i">
                    <template slot="title">
                      <i style="font-size: 20px !important; color: #409EFF; " class="header-icon el-icon-tickets"></i>&nbsp; <h4> {{h.label}} </h4>
                    </template>
                    <div class="text-left pl-4">
                      {{h.description}}
                    </div>
                    <div class="text-left pl-4" v-html="h.content">
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>    
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Collapse, CollapseItem, Input } from 'element-ui';
export default {
  name: 'help-center',
  components: {
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Input.name]: Input,
  },
  data() {
    return {
      items: [
      ],
      filter: ""
    }
  },
  mounted() {
    this.initializeItems()
  },
  methods: {
    initializeItems() {
      this.items =  [
        {
          label: "¿Puedo cambiar mi contraseña actual?",
          description: "Si, sigue los pasos:",
          content: "<ul><li>En el menú de la barra de navegación, selecciona la opción Mi Perfil</li><li>En el menú lateral izquierdo, selecciona la opción Contraseña</li><li>Ingresa la nueva contraseña</li><li>Confirma la contraseña y selecciona el botón Cambiar contraseña.</li></ul>"
        },
        {
          label: "¿Dónde puedo ver mis notificaciones?",
          description: "Para ver tus notificaciones:",
          content: "En el menú de la barra de navegación, selecciona el icono de la campana."
        },
        {
          label: "¿Dónde puedo ver mis inversiones realizadas?",
          description: "Para ver tus inversiones:",
          content: "En el menú de la barra de navegación, selecciona la opción Inversiones"
        },
        {
          label: "¿Puedo actualizar mi información personal?",
          description: "Si, sigue los pasos:",
          content: "<ul><li>En el menú de la barra de navegación, selecciona la opción Mi Perfil</li><li>En el menú lateral izquierdo, selecciona la opción Perfil</li><li>Actualiza la información necesaria</li><li>Y selecciona el botón Guardar.</li></ul>"
        },
        {
          label: "Cerrar mi sesión",
          description: "",
          content: "En el menú de la barra de navegación, selecciona la opción Cerrar Sesión."
        }
      ]
    },
    getItems(ev) {
      
    }
  },
  watch: {
    filter(){
      // Reset items back to all of the items
      this.initializeItems();

      // set val to the value of the searchbar
      const val = this.filter;

      // if the value is an empty string don't filter the items
      if (val && val.trim() != '') {
        this.items = this.items.filter((item) => {
          return (item.label.toLowerCase().indexOf(val.toLowerCase()) > -1);
        })
      }
    }
  }
};
</script>
<style lang="css" scoped>
.pl-4 {
  font-size: 14px;
}
</style>